import React from 'react';
import PropTypes from 'prop-types';
import { Placeholder } from './../loading-state/placeholder';
import { Link } from 'react-router';

export class ContentVideoHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    displayChannelTitle() {
        return (
            <div className="content-video-header__channel-title" title={this.props.channelTitle}>{this.props.channelTitle}</div>
        );
    }

    displayChannelLogo() {
        const { channelLogo } = this.props;
        return (
            <span>
            {channelLogo ? <img className="content-video-header__channel-logo" alt="" src={channelLogo} /> : null}
            </span>
        );
    }

    displayContentVideoHeader() {
        const { isFetching } = this.props;
        return (<div className="content-video-header" onClick={this.props.contentHeaderOnClickHandler.bind(this)}>
                {isFetching ? <Placeholder height={'25px'} width={'25px'} borderRadius={'3px'} margin={'3px 18px'} /> : this.displayChannelLogo()}
                {isFetching ? <Placeholder height={'10px'} width={'50%'} borderRadius={'3px'} margin={'-22px 0px 0px 55px'} /> : this.displayChannelTitle()}
        </div>
        );
    }
    displayHeaderWithChannelPageLink() {
        const { channelKey } = this.props;
        return (
            <div>
                {channelKey ?
                    <Link to={`/channel/${channelKey}`}>
                    {this.displayContentVideoHeader()}
                    </Link> :
                this.displayContentVideoHeader()}
            </div>
        );
    }

    render() {
        return (this.displayHeaderWithChannelPageLink());
    }
}

ContentVideoHeader.propTypes = {
    channelLogo: PropTypes.string,
    channelTitle: PropTypes.string.isRequired,
    channelKey: PropTypes.string.isRequired,
    contentHeaderOnClickHandler: PropTypes.func,
    isFetching: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/content/content-video-header.js